//数据缓存
module.exports = {};